import { UserRole } from '@wineryxplorer/shared';
import { Button } from '../../components/ui/Button';
import { TABS } from './constants';
import type { TabType } from './constants';

interface WineryEditHeaderProps {
  userRole: UserRole;
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
  isValid: boolean;
  hasValidationErrors: boolean;
}

export const WineryEditHeader = ({
  userRole,
  activeTab,
  onTabChange,
  onSave,
  onCancel,
  isSaving,
  isValid,
  hasValidationErrors,
}: WineryEditHeaderProps) => (
  <div className="border-b border-gray-200 pb-6">
    <h1 className="text-3xl font-bold text-gray-900 mb-6">Edit Venue</h1>

    {/* Action Buttons - Top of Page */}
    <div className="flex gap-4 mb-8 justify-end">
      <Button variant="primary" onClick={onSave} disabled={isSaving || !isValid} loading={isSaving}>
        {isSaving ? 'Saving...' : 'Save Changes'}
      </Button>
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
    </div>

    {!isValid && hasValidationErrors && (
      <div className="mb-6 text-sm text-red-600">
        Please fix the validation errors below before saving.
      </div>
    )}

    {/* Tab Navigation */}
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {TABS.filter((tab) => {
          // Only show Admin tab to SITE_ADMIN and SUPER_ADMIN
          if (tab.id === 'admin') {
            return userRole === UserRole.SITE_ADMIN || userRole === UserRole.SUPER_ADMIN;
          }
          return true;
        }).map((tab) => (
          <Button
            key={tab.id}
            variant="ghost"
            onClick={() => onTabChange(tab.id)}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </Button>
        ))}
      </nav>
    </div>
  </div>
);
